const blogSchema = (blog, slug) => {
  const siteUrl = "https://ldlsettlementservices.com.au";

  const imageUrl = blog.image?.startsWith("http")
    ? blog.image
    : `${siteUrl}${blog.image}`;

  const articleUrl = `${siteUrl}/blog/${slug}`;

  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",

    "@id": `${articleUrl}#article`,

    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": articleUrl
    },

    "headline": blog.title,

    "description": blog.metaDesc,

    "image": [
      imageUrl
    ],

    "datePublished": blog.date,

    "dateModified": blog.date,

    "author": {
      "@type": "Organization",
      "name": "LDL Settlement Services",
      "url": siteUrl
    },

    "publisher": {
      "@type": "Organization",
      "name": "LDL Settlement Services",
      "url": siteUrl,
      "logo": {
        "@type": "ImageObject",
        "url": `${siteUrl}/Images/logo.webp`
      }
    },

    "articleSection": blog.category,

    "url": articleUrl
  };
};

export default blogSchema;